import { AllocationProtocolDTO } from "../DTO/allocationProtocolDTO";
import { AppService } from "../app.service";
import { AllocationField } from "./allocationField";
import { AllocationRule } from "./allocationRule";
import { FieldDefinition } from "./fieldDefinition";

export class AllocationProtocol {

    public id!: number;
    public sequenceNo!: number;
    public keyFieldReferences!: AllocationField[];
    public keyFields!: FieldDefinition[];
    public allocationFieldReference!: AllocationField;
    public allocationField!: FieldDefinition;
    public allocationFieldMethod!: number;
    public creditFieldReference!: AllocationField;
    public creditField!: FieldDefinition;
    public debitFieldReference!: AllocationField;
    public debitField!: FieldDefinition;
    public allocationRules!: AllocationRule[];

    public keyFieldsInfo:string='';
    public allocationFieldInfo:string='';
    public allocationFieldMethodInfo:string='';
    public creditFieldInfo:string='';
    public debitFieldInfo:string='';

    constructor(){
        this.allocationRules = new Array();
        this.keyFieldReferences = new Array();
        this.keyFields = new Array();
    }

    public createFieldDefinitions(fieldDefinitions:FieldDefinition[]){
        if(this.keyFieldReferences) {
            this.keyFieldReferences.forEach(kfr=>{
                let fd = fieldDefinitions.find(f=>f.index==kfr.index);
                if(fd) {
                    this.keyFields.push(fd);
                }
            });
        }
        if(this.allocationFieldReference) {
            this.allocationField = fieldDefinitions.find(f=>f.index==this.allocationFieldReference.index)!;
        }
        if(this.creditFieldReference) {
            this.creditField = fieldDefinitions.find(f=>f.index==this.creditFieldReference.index)!;
        }
        if(this.debitFieldReference) {
            this.debitField = fieldDefinitions.find(f=>f.index==this.debitFieldReference.index)!;
        }
        this.allocationRules.forEach(ar=>{
            ar.createFieldDefinitions(fieldDefinitions);
        });
        this.updateInfo();
    }

    public updateInfo(){
        this.keyFields.forEach(kf=>{
            this.keyFieldsInfo += kf.name + ", ";
        });
        if(this.keyFieldsInfo.length>0) this.keyFieldsInfo=this.keyFieldsInfo.substring(0, this.keyFieldsInfo.length-2);
        this.allocationFieldInfo = this.allocationField?.name;
        this.allocationFieldMethodInfo = AppService.allocationFieldMethodsArray.find(afm=>afm.id==this.allocationFieldMethod)?.name ?? '';
        this.creditFieldInfo = this.creditField?.name;
        this.debitFieldInfo = this.debitField?.name;
    }

    public static mapFromDTO(param:AllocationProtocolDTO):AllocationProtocol{ 
        if (!param) throw new Error("parameter is null")
        let obj = new AllocationProtocol();
        try
        {
            obj.id = param.id;
            obj.sequenceNo = param.sequenceNo;
            if(param.keyFieldReferences){
                obj.keyFieldReferences = JSON.parse(param.keyFieldReferences);
            }
            if(param.allocationFieldReference){
                obj.allocationFieldReference = JSON.parse(param.allocationFieldReference);
            }
            if(param.creditFieldReference){
                obj.creditFieldReference = JSON.parse(param.creditFieldReference);
            }
            if(param.debitFieldReference){
                obj.debitFieldReference = JSON.parse(param.debitFieldReference);
            }
            obj.allocationFieldMethod = param.allocationFieldMethod;
            obj.allocationRules = param.allocationRules.map(ar=>AllocationRule.mapFromDTO(ar));
        }
        catch(e)
        {
            console.log(e);
            
        }
        return obj;
    }

    public static mapToDTO(param:AllocationProtocol):AllocationProtocolDTO{ 
        if (!param) throw new Error("parameter is null")
        let dto = new AllocationProtocolDTO();
        try
        {
            dto.id = param.id;
            dto.sequenceNo = param.sequenceNo;
            if(param.keyFields) {
                let kfArray:AllocationField[] = [];
                param.keyFields.forEach(kf=>{
                    kfArray.push(kf.allocationField);
                });
                dto.keyFieldReferences = JSON.stringify(kfArray);
            }
            if(param.allocationField)  dto.allocationFieldReference = JSON.stringify(param.allocationField.allocationField);
            if(param.creditField) dto.creditFieldReference = JSON.stringify(param.creditField.allocationField);
            if(param.debitField) dto.debitFieldReference = JSON.stringify(param.debitField.allocationField);
            dto.allocationFieldMethod = param.allocationFieldMethod;
            dto.allocationRules = param.allocationRules.map(ar=>AllocationRule.mapToDTO(ar));
        }
        catch(e)
        {
            console.log(e);
            
        }
        return dto;
    }

    //use DTO to create a deep copy
    get clone():AllocationProtocol{
        let mappedAllocationProtocol=AllocationProtocol.mapToDTO(this);
        mappedAllocationProtocol.id=0;
        mappedAllocationProtocol.allocationRules.forEach(r=>{
            r.id=0;
        });
        let mapFromDTOAllocationProtocol = AllocationProtocol.mapFromDTO(mappedAllocationProtocol);
        return mapFromDTOAllocationProtocol;
    }
}